'use client'

import { useLayoutEffect } from 'react'

/**
 * Owns the document title for the not-found boundary.
 * Next keeps SSR 404 metadata briefly, then swaps <title> to the locale
 * layout default (e.g. Yaponamama) when notFound() cancels the page segment.
 */
export default function NotFoundDocumentTitle({ title }: { title: string }) {
  useLayoutEffect(() => {
    const apply = () => {
      if (document.title !== title) {
        document.title = title
      }
    }

    apply()

    const observer = new MutationObserver(apply)
    observer.observe(document.head, { childList: true, subtree: true })

    return () => observer.disconnect()
  }, [title])

  return null
}
